<template>
  <div>
    <div class="mb-4 py-4">
      <form @change="getDate">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="username"
          >Zgjedhe Daten TESTING GIT SECOND TIME:</label
        >
        <div class="w-40">
          <vc-date-picker
            v-model="date"
            :first-day-of-week="2"
            :masks="{ title: 'MMMM YYYY', L: 'DD-MM-YYYY' }"
          ></vc-date-picker>
        </div>
      </form>
      <form>
        <div class="pt-4" v-if="isAdmin">
          <label
            class="block text-gray-700 text-sm font-bold mb-2"
            for="username"
            >Zgjedhe perdoruesin:</label
          >
          <div class="inline-block relative">
            <select
              class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
              v-model="user"
            >
              <option>Zgjedh</option>
              <option v-for="(user, id) in users" :value="user.id" :key="id">
                {{ user.name }}
              </option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="flex flex-wrap">
      <div class="py-2 sm:m-1">
        <a
          target="_blank"
          class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          :href="
            'https://api.homeface.de/report/' + user + '/' + formatDate(date)
          "
          >Eksporto raportin</a
        >
      </div>
      <div class="py-2 sm:m-1" v-if="isAdmin">
        <a
          target="_blank"
          class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          :href="'https://api.homeface.de/raporti-ditor/' + formatDate(date)"
          >Eksporto raportin e pergjithshem</a
        >
      </div>
      <div class="py-2 sm:m-1">
        <a
          v-if="isAdmin"
          target="_blank"
          class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          :href="'https://api.homeface.de/raporti-ei/' + formatDate(date)"
          >Eksporto raportin HF Staff</a
        >
        <a
          v-else
          target="_blank"
          class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          :href="
            'https://api.homeface.de/raporti-hf/' +
            user +
            '/' +
            formatDate(date)
          "
          >Eksporto raportin HF Staff</a
        >
      </div>
      <div class="py-2 sm:m-1" v-if="isAdmin">
        <a
          target="_blank"
          class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          :href="'https://api.homeface.de/raporti-deleted/' + formatDate(date)"
          >Eksporto detyrat e fshiera</a
        >
      </div>
      <div class="py-2 sm:m-1" v-if="isAdmin">
        <router-link
          to="/screen-tasks"
          class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          >Shfaq detyrat ne ekran</router-link
        >
      </div>
      <div class="py-2 sm:m-1">
        <router-link
          to="/monthly-ratings"
          class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          >Vlersimet Mujore</router-link
        >
      </div>
      <div class="py-2 sm:m-1">
        <router-link
          to="/weekly-tasks"
          class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          >Detyrat javore</router-link
        >
      </div>
    </div>
    <div class="flex">
      <div class="mb-4">
        <router-link
          to="/fast-tasks"
          class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          >Detyrat e shpejta</router-link
        >
      </div>
    </div>
    <div>
      <Day :date="formatDate(date)" :user="user" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Day from "../excel/days/Day";
import moment from "moment";

export default {
  components: {
    Day,
  },
  data() {
    return {
      isModalVisible: false,
      isAdmin: false,
      date: new Date(),
      id: "",
      value: "",
      user_id: null,
      users: [],
      user: null,
    };
  },
  created() {
    this.getUser();
    this.getUsers();
  },

  methods: {
    getUser() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios.get(`${process.env.VUE_APP_API}/user`).then((response) => {
        this.user = response.data.data.id;
        // console.log(this.user);
        // console.log(this.id);
        if (response.data.data.is_admin) {
          this.isAdmin = true;
        } else {
          this.isAdmin = false;
        }
      });
    },

    getUsers() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .get(`${process.env.VUE_APP_API}/excel/users`)
        .then((response) => {
          this.users = response.data;
          // console.log(this.users);
        })
        .catch((error) => console.log(error));
    },

    getDate() {},
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>

<style></style>
